import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import PlayStore from './FooterImages/playstore.png';
import AppStore from './FooterImages/appstore.png'
import Logo from '../Nav/NavImages/logo.png'

function Footer() {
    return (
        <>
            <div className='footer-container'>
                <section className='footer-subscription'>
                    <h1 className='footer-subscription-heading'>
                        Download  <span className="span-txt-footer">WeShare</span>  Sekarang<br />
                    </h1>
                    <p className='footer-subscription-text'>
                        Mari Berbagi dengan mereka yang membutuhkan.<br /> Bantuanmu sangat berharga untuk mereka.
                    </p>
                    <div className='input-areas'>
                        <form className="footer-form">
                            {/* <input
                                className='footer-input'
                                name='email'
                                type='email'
                                placeholder='Your Email'
                            /> */}
                            <button className="btn-2"><Link to="/daftar">Daftar</Link></button>
                        </form>
                    </div>
                </section>
                <div class='footer-links'>
                    <div className='footer-link-wrapper'>
                        <div class='footer-link-items'>
                            <h2 className="footer-txt">Menu</h2>
                            <Link to='/'>Ayo Donasi</Link>
                            <Link to='/'>Buka Donasi</Link>
                            <Link to='/tentangkami'>Tentang Kami</Link>
                        </div>
                        <div class='footer-link-items'>
                            <h2 className="footer-txt">Lokasi Kami</h2>
                            <Link to='/'>Jalan Hayam Wuruk No. 88</Link>
                            <Link to='/'>Jakarta Barat</Link>
                        </div>
                        <div class='footer-link-items'>
                            <h2 className="footer-txt">Hubungi Kami</h2>
                            <Link to='/'>Email: contact@weshare.id</Link>
                            <Link to='/'>Telp: (021) 3920192</Link>
                        </div>
                        <div className="download-app">
                            <a href="https://play.google.com/store?hl=in&gl=US" ><img src={PlayStore} alt="" width="200" height="80" /></a>
                            <a href="https://www.apple.com/id/app-store/" ><img src={AppStore} alt="" width="200" height="100" /></a>
                        </div>
                    </div>
                    <div className='footer-link-wrapper'>
                    </div>
                </div>
                <section class='social-media'>
                    <div class='social-media-wrap'>
                        <div class='footer-logo'>
                            <Link to='/' className='social-logo'>
                                <img src={Logo} alt="" width="130" height="120" />
                                <h5 className="social-logo-txt">WeShare</h5>
                            </Link>
                        </div>
                        <small class='website-rights'>WeShare © 2021</small>
                        <div class='social-icons'>
                            <Link
                                class='social-icon-link facebook'
                                to='/'
                                target='_blank'
                                aria-label='Facebook'
                            >
                                <i class='fab fa-facebook-f' />
                            </Link>
                            <Link
                                class='social-icon-link instagram'
                                to='/'
                                target='_blank'
                                aria-label='Instagram'
                            >
                                <i class='fab fa-instagram' />
                            </Link>
                            <Link
                                class='social-icon-link youtube'
                                to='/'
                                target='_blank'
                                aria-label='Youtube'
                            >
                                <i class='fab fa-youtube' />
                            </Link>
                            <Link
                                class='social-icon-link twitter'
                                to='/'
                                target='_blank'
                                aria-label='Twitter'
                            >
                                <i class='fab fa-twitter' />
                            </Link>
                            <Link
                                class='social-icon-link twitter'
                                to='/'
                                target='_blank'
                                aria-label='LinkedIn'
                            >
                                <i class='fab fa-linkedin' />
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default Footer;
